export const queryKeys = {
    PUSH_NOTIFICATIONS_CONFIG: "PUSH_NOTIFICATIONS_CONFIG",
    DEVICE_TOKEN_UPDATE: "DEVICE_TOKEN_UPDATE",
    PUSH_NOTIFICATIONS_CONFIG_CLEAN: "PUSH_NOTIFICATIONS_CONFIG_CLEAN"
};